import React, { useState } from "react";
import "./Contact.css";
import { Container } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import MuiAlert from "@mui/material/Alert";
import { Slide, Snackbar, Stack } from "@mui/material";
const Contact = () => {
  const TransitionDown = (props) => {
    return <Slide {...props} direction="down" />;
  };
  const form = useRef();

  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal } = state;

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [open, setOpen] = React.useState(false);

  const [varientCheck, setVarient] = useState("success");

  const handleClick = (vari) => {
    setVarient(vari);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const [value, setValue] = useState({
    user_name: "",
    phone_number: "",
    user_email: "",
    user_subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setValue(...value, { [name]: value });
  };
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          handleClick("success");
          setValue({
            user_name: "",
            phone_number: "",
            user_email: "",
            user_subject: "",
            message: "",
          });
        },
        (error) => {
          handleClick("error");
          console.log(error.text);
        }
      );
  };
  return (
    <div className="BG-Contact" id="contact">
      <Container>
        <div className="after">
          <h1>Contact With Me</h1>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <div className="Contact-main-div">
            <input
              type="text"
              name="user_name"
              placeholder="Your Name"
              required
              autoComplete="off"
              value={value.user_name}
              onChange={handleChange}
            />

            <input
              type="text"
              name="phone_number"
              placeholder="Your Phone Number"
              required
              autoComplete="off"
              value={value.phone_number}
              onChange={handleChange}
            />

            <input
              type="email"
              name="user_email"
              placeholder="Your Email"
              required
              autoComplete="off"
              value={value.user_email}
              onChange={handleChange}
            />

            <input
              type="text"
              name="user_subject"
              placeholder="Subject Here"
              required
              autoComplete="off"
              value={value.user_subject}
              onChange={handleChange}
            />

            <textarea
              required
              name="message"
              id="message"
              placeholder="Type Here"
              cols="30"
              rows="5"
              autoComplete="off"
              value={value.message}
              onChange={handleChange}
            ></textarea>

            <input type="submit" value="Send Message" />
          </div>
        </form>
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            TransitionComponent={TransitionDown}
          >
            <Alert
              onClose={handleClose}
              severity={varientCheck}
              sx={{ width: "100%" }}
            >
              {varientCheck === "success"
                ? "Your Message is send successfully!"
                : "Sending Message Error"}
            </Alert>
          </Snackbar>
        </Stack>
      </Container>
    </div>
  );
};

export default Contact;
